import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from '@dnd-kit/sortable';
import TextAreaInput from '../../../../inputs/form-inputs/TextAreaInput';
import SortableItem from '../../../../dnd-kit/SortableItem/SortableItem';

export default function RepeaterInput({ onChange, value = [] }) {
  const handleAddRepeaterItem = () => {
    onChange([...value, { id: crypto.randomUUID(), content: '' }]);
  };

  const handleRemoveRepeaterItem = (repeaterItemId) => {
    onChange(value.filter((r) => r.id !== repeaterItemId));
  };

  const handleUpdateRepeaterItem = (repeaterItemId, updatedRepaterItem) => {
    const updatedValue = value.map((t) => (t.id === repeaterItemId ? updatedRepaterItem : t));
    onChange(updatedValue);
  };

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = value.findIndex((m) => m.id === active.id);
      const newIndex = value.findIndex((m) => m.id === over.id);

      // Reorder the metadata entries
      const newData = arrayMove(value, oldIndex, newIndex);

      onChange(newData);
    }
  };

  return (
    <div className="dp-repeater">
      {value && value.length ? (
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
          <SortableContext items={value} strategy={verticalListSortingStrategy}>
            {value.map((repeaterItem, index) => {
              return (
                <SortableRepeaterItem
                  key={repeaterItem.id}
                  {...{
                    index,
                    onChange: handleUpdateRepeaterItem,
                    repeaterItem,
                    handleRemoveRepeaterItem,
                  }}
                />
              );
            })}
          </SortableContext>
        </DndContext>
      ) : (
        <span className="text-muted text-center">Click "Add Item" below to add your first repeater item.</span>
      )}
      <button className="btn btn-primary" onClick={handleAddRepeaterItem}>
        Add Item (<i className="fe fe-plus" />)
      </button>
    </div>
  );
}

function SortableRepeaterItem({ index, onChange, repeaterItem, handleRemoveRepeaterItem }) {
  const { id, content } = repeaterItem;

  const handleUpdateRepeaterItem = (updatedRepeaterItem) => {
    onChange(id, updatedRepeaterItem);
  };

  return (
    <SortableItem id={id}>
      <div className="dp-repeater-item">
        <h4 className="dp-repeater-item-number">{`#${index + 1}`}</h4>
        <TextAreaInput
          className="form-control text-area-fit"
          value={content || ''}
          onChange={(e) => handleUpdateRepeaterItem({ ...repeaterItem, content: e.target.value })}
          rows={1}
        />
        <div className="d-flex align-items-center justify-content-center">
          <button type="button" className="btn btn-danger" onClick={() => handleRemoveRepeaterItem(id)}>
            <i className="fe fe-trash" />
          </button>
        </div>
      </div>
    </SortableItem>
  );
}
